import {
  GET_CUSTOMER_BOOKING_PAGE,
  SET_CUSTOMER_BOOKING_PAGE,
  SET_BUSINESS_DETAIL,
  SET_BUSINESS_ID,
  SET_BUSINESS_LOCATION_ID,
  SET_BUSINESS_TYPE_ID,
} from "../constants/ActionTypes";

export const getCustomerBookingPage = () => ({
  type: GET_CUSTOMER_BOOKING_PAGE,
});

export const setCustomerBookingPage = payload => ({
  type: SET_CUSTOMER_BOOKING_PAGE,
  payload,
});

export const setBusinessDetail = businesses => ({
  type: SET_BUSINESS_DETAIL,
  businesses,
});

export const setBusinessIds = businessId => ({
  type: SET_BUSINESS_ID,
  businessId,
});

export const setBusinessLocationIds = businessLocationId => ({
  type: SET_BUSINESS_LOCATION_ID,
  businessLocationId,
});

export const setBusinessTypeId = payload => ({
  type: SET_BUSINESS_TYPE_ID,
  payload,
});



// WEBPACK FOOTER //
// ./actions/CustomerBooking.js